<template>
  <div id="poster">
    <div
      v-show="!saving"
      id="poster-container"
      :class="templateName === '模板1' ? '' : 'poster-container_temp2'"
    >
      <div :class="templateName === '模板1' ? 'poster__qrcode' : 'poster__qrcode_temp2'">
        <vue-qrcode
          :color="colors"
          :margin="margin"
          :quality="quality"
          :type="type"
          :value="qrcodeValue"
          :width="width"
        ></vue-qrcode>
      </div>
      <div
        v-if="posterTitle !== '' || posterData.length > 0"
        :class="templateName === '模板1' ? 'poster__table' : 'poster__table_temp2'"
      >
        <table>
          <thead>
            <tr>
              <th colspan="2" scope="col">
                {{ posterTitle }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in posterData" :key="index.toString()">
              <td>{{ item.key }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-show="saving" id="poster__image"></div>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'
import html2canvas from 'html2canvas'
import { mapState, mapMutations, mapGetters } from 'vuex'

let _this = void 0

export default {
  name: 'Poster',
  components: {
    VueQrcode,
  },
  filters: {},
  mixins: [],
  props: {},
  data() {
    return {
      saving: false,
      // 二维码值
      qrcodeValue: '自定义标题',
      // 二维码色块值   width: 187,
      colors: {
        dark: '#000000FF',
        light: '#FFFFFFFF',
      },
      // 二维码外边距(px)
      margin: 0,
      // 二维码质量 0~1
      quality: 1,
      // 二维码边长(px)
      width: 187,
      // 二维码生成图片的格式
      type: 'image/png',
    }
  },
  computed: {
    ...mapState('editor', {
      posterTitle: state => state.posterTitle,
      posterData: state => state.posterData,
      qrcodeImageRefresh: state => state.qrcodeImageRefresh,
      templateName: state => state.templateName,
      editorStatus: state => state.editorStatus,
    }),
  },
  watch: {
    posterTitle() {
      this.getQrcodeValueLink()
      this.refreshImage()
    },
    qrcodeImageRefresh(val) {
      if (val) {
        this.refreshImage()
      }
    },
    templateName(val) {
      this.width = val === '模板1' ? 187 : 65
    },
  },
  created() {
    _this = this
    if (this.editorStatus === 'create') {
      this.setPosterData([])
      this.setPosterTitle('自定义标题')
    }
  },
  mounted() {
    this.width = this.templateName === '模板1' ? 187 : 65
  },
  methods: {
    ...mapMutations('editor', ['setQRCodeFile', 'setPosterData', 'setPosterTitle']),
    ...mapGetters('editor', ['getQrcodeId']),
    /**
     * 生成海报图片
     */
    refreshImage() {
      this.$nextTick(() => {
        html2canvas(document.querySelector('#poster-container')).then(canvas => {
          const image = new Image()
          image.src = canvas.toDataURL(_this.type)
          document.querySelector('#poster__image').innerHTML = ''
          document.querySelector('#poster__image').appendChild(image)
          // 更新二维码海报文件
          const file = _this.base64DataToFile(image.src, _this.posterTitle ?? '未命名')
          _this.setQRCodeFile(file)
          _this.$nextTick(() => {
            _this.saving = false
            if (_this.qrcodeImageRefresh) {
              this.$emit('refreshImageStatus', 'done')
            }
          })
        })
      })
    },
    /**
     * base64转文件
     * @param base64Data {string}
     * @param filename {string}
     * @returns {File}
     */
    base64DataToFile(base64Data, filename) {
      const arr = base64Data.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const blobStr = atob(arr[1])
      let n = blobStr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = blobStr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${mime.split('/')[1]}`, { type: mime })
    },
    /*
     * 获取二维码链接
     * */
    getQrcodeValueLink() {
      const qrcodeId = this.getQrcodeId()
      const link = `${WEB_CONFIG.BASE_URL}/#/qrcode-preview?qrcodeId=${qrcodeId}`
      //const link = `http://192.168.191.7:3000//#/qrcode-preview?qrcodeId=${qrcodeId}`
      this.qrcodeValue = link
      //console.log('qrcodeLink..', link)
    },
  },
}
</script>

<style lang="scss" scoped>
#poster {
  min-height: 230px;
  background: #ffffff;

  .poster-container_temp2 {
    display: flex;
  }
  #poster-container {
    width: 416px;
    min-height: 187px;
    background: #ffffff;
    padding: 16px;
    box-sizing: border-box;

    .poster__qrcode {
      padding: 10px 0;
      background: #ffffff;
      height: 227px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .poster__qrcode_temp2 {
      margin: 5px auto;
      padding-right: 5px;
      min-height: 280px;
    }
    .poster__table {
      margin-top: 10px;
      background: #f5f5f5;

      table {
        width: 100%;
        border: 1px solid #dcdcdc;
        margin: 10px 0;
        box-sizing: border-box;
        border-collapse: collapse; /* 边框合并属性  */
      }
      th {
        min-height: 40px;
        border: 1px solid #dcdcdc;
        padding: 12px;
        text-align: center;
        font-weight: 400;
      }
      td {
        min-height: 40px;
        border: 1px solid #dcdcdc;
        padding: 10px 10px;
        font-weight: 400;
        color: #222222;
        border-collapse: separate;
        text-indent: initial;
        border-spacing: 2px;
        outline: none;
        font-size: 14px;
      }
    }
    .poster__table_temp2 {
      flex: 1;
      table {
        width: 100%;
        border: 1px solid #dcdcdc;
        margin: 5px 0;
        box-sizing: border-box;
        border-collapse: collapse; /* 边框合并属性  */
      }

      th {
        min-height: 40px;
        border: 1px solid #dcdcdc;
        padding: 12px;
        text-align: left;
        font-weight: normal;
        background-color: #f5f5f5;
      }
      td {
        min-height: 40px;
        border: 1px solid #dcdcdc;
        padding: 10px 10px;
        font-weight: 400;
        color: #222222;
        border-collapse: separate;
        text-indent: initial;
        border-spacing: 2px;
        outline: none;
        font-size: 14px;
        background-color: #f5f5f5;
      }
    }
    table td:first-child {
      width: 30%;
    }
  }
}
</style>

<style lang="scss">
#poster__image {
  img {
    width: 100%;
  }
}
</style>
